/* globals GIG */

'use strict';

const { h, Component } = require('phy');
const FetchHandler = require('../../deal/frontend/FetchHandler');
require('groupon-iframe-login');

const EducationDesktop = require('./education_desktop');
const EducationTouch = require('./education_touch');
const InfoComponent = require('./information');
const SelectNotification = require('./notification');

const {
  SELECT_ENROLL_SUCCESS_MESSAGE,
  SELECT_ENROLL_FAILURE_MESSAGE,
  SELECT_ENROLL_CANCELLED_MESSAGE,
  SELECT_ENROLL_EXISTING_CARD_SRC,
  SELECT_ENROLL_ADD_CARD_SRC,
} = require('../utils/constants');

class SelectWidgetContainer extends Component {
  constructor(props) {
    super(props);
    this.bindAll();
    this.state = { isUserStatusSet: null };
  }

  bindAll() {
    this.benefitsFetchSuccess = this.benefitsFetchSuccess.bind(this);
    this.handleEnrollmentMessages = this.handleEnrollmentMessages.bind(this);
    this.handleOpenModalClick = this.handleOpenModalClick.bind(this);
    this.initializeEducation = this.initializeEducation.bind(this);
    this.setIframeHeight = this.setIframeHeight.bind(this);
  }

  componentDidMount() {
    this.lazyLoadUserStatus();
  }

  componentDidUpdate() {
    if (
      this.state.isUserStatusSet &&
      !this.props.touchRequest &&
      !this.state.isEnrolled
    ) {
      this.initializeEducation();
    } else if (this.state.isEnrolled && this.$modalIframe) {
      this.$modalIframe.remove();
    }
    GIG.Alerts.init();
  }

  componentDidUnmount() {
    window.removeEventListener('message', this.handleEnrollmentMessages);
  }

  showSelectNotification(selector) {
    const notificationSelector = document.querySelector(selector);
    if (notificationSelector) notificationSelector.style.display = 'block';
  }

  handleEnrollmentMessages(message) {
    message.preventDefault();
    switch (message.data) {
      case SELECT_ENROLL_SUCCESS_MESSAGE: {
        this.setIframeHeight();
        this.lazyLoadUserStatus();
        this.showSelectNotification('.select-alerts .notification.success');
        GIG.Modal.close();
        break;
      }
      case SELECT_ENROLL_FAILURE_MESSAGE: {
        this.setIframeHeight();
        this.showSelectNotification('.select-alerts .alert.error.system');
        GIG.Modal.close();
        break;
      }
      case SELECT_ENROLL_CANCELLED_MESSAGE: {
        GIG.Modal.close();
        break;
      }
    }
  }

  setIframeHeight() {
    const iframeContentHeight = this.$modalIframe.contentWindow.document.body
      .scrollHeight;
    const { paddingTop, paddingBottom } = getComputedStyle(this.$modalIframe);
    this.$modalIframe.style.width = '100%';
    this.$modalIframe.height = `${iframeContentHeight +
      parseInt(paddingTop) +
      parseInt(paddingBottom)}px`;
  }

  updateIframe() {
    if (!this.$modalIframe) {
      this.initializeIframe();
    } else if (
      this.$modalIframe &&
      this.$modalIframe.contentWindow &&
      !this.$modalIframe.contentWindow.location.pathname.match(
        this.getIframeSource()
      )
    ) {
      this.$modalIframe.src = this.getIframeSource();
    }
  }

  getIframeSource() {
    return this.state.hasCards
      ? SELECT_ENROLL_EXISTING_CARD_SRC
      : SELECT_ENROLL_ADD_CARD_SRC;
  }

  initializeIframe() {
    this.$modalIframe = document.querySelector('#select-enrollment-iframe');
    const $modalIframeColumn = document.querySelector(
      '#enrollment-modal-iframe-column'
    );

    if (this.$modalIframe) {
      this.$modalIframe.onload = () => {
        this.setIframeHeight();
        $modalIframeColumn.classList.remove('gig-spinner', 'gig-spinner-brnd');
      };
      this.$modalIframe.src = this.getIframeSource();
    }
  }

  benefitsFetchSuccess(data) {
    if (data) {
      document.querySelector('#enrollment-modal-benefits').innerHTML =
        data.html;
    }
  }

  initializeBenefits() {
    const benefitsHandler = new FetchHandler({
      url: '/programs/select/benefits',
      requestOpts: {
        credentials: 'same-origin',
        method: 'get',
        contentType: 'application/json',
      },
      successHandlers: data => this.benefitsFetchSuccess(data),
      errorHandlers: [],
    });
    benefitsHandler.send();
  }

  openEducationModal() {
    this.updateIframe();
    GIG.Modal.open({ el: this.$educationModal });
  }

  openLoginIframe() {
    if (window.payload.iframeLogin) {
      window.IframeLogin.openModal();
      if (window.IframeLogin.$iframe) {
        window.IframeLogin.updateHeight(
          window.IframeLogin.$iframe.contentWindow.document.body.scrollHeight
        );
      }
    }
  }

  handleOpenModalClick(e) {
    e.preventDefault();
    this.state.isLoggedIn ? this.openEducationModal() : this.openLoginIframe();
  }

  initializeEducation() {
    this.$educationModal = document.querySelector(
      '#select-widget-enrollment-modal'
    );

    if (this.state.isLoggedIn) {
      this.initializeBenefits();
      window.addEventListener('message', this.handleEnrollmentMessages);
    } else if (window.payload.iframeLogin) {
      window.IframeLogin.lazyLoadIframe();
    }
  }

  lazyLoadUserStatus() {
    const handler = new FetchHandler({
      url: '/deals/user_proxy/select_enrollment_status',
      requestOpts: { credentials: 'same-origin' },
      successHandlers: userStatus =>
        this.setState({ isUserStatusSet: true, ...userStatus }),
      errorHandlers: () => this.setState({ isUserStatusSet: false }),
    });
    handler.send();
  }

  render() {
    if (this.state.isUserStatusSet) {
      if (this.state.isEnrolled) {
        return h(
          'div',
          !this.props.touchRequest ? h(SelectNotification, this.props) : h(),
          h(InfoComponent, { ...this.props, hideByDefault: false })
        );
      }
      if (this.props.touchRequest) {
        return h(EducationTouch, this.props);
      }
      return h(
        'div',
        h(SelectNotification, this.props),
        h(EducationDesktop, {
          ...this.props,
          handleLearnMoreClick: this.handleOpenModalClick,
        })
      );
    }
    return h('div');
  }
}

module.exports = SelectWidgetContainer;
